import React from 'react';
import common from '../../common/common';
import styles from './scenes.module.scss';

// 移动壳：星星总量 + 兑换（路由跳转）
export function MobileTotal({ balance, showExchangeBtn, history }) {
  const showExchange = () => {
    history.push({
      pathname: '/exchange',
      search: common.withMobileShellSearch(window.location.search),
    });
  };

  return (
    <div className={styles.mobileTotalStar}>
      <div className={styles.mobileTotalWrap}>
        <div className={styles.totalStarIcon} />
        <div className={styles.totalStar}>
          <p className={styles.totalLabel}>星星总量</p>
          <p className={styles.totalCount}>{balance}</p>
        </div>
        {showExchangeBtn && (
          <div className={styles.exchangeBtn} onClick={showExchange}>
            <i className={styles.exchangeBtnIcon} />
            <label className={styles.exchangeBtnLabel}>星星兑换</label>
          </div>
        )}
      </div>
    </div>
  );
}

// 移动壳：攻略 / 明细（路由跳转）
export function MobileRightEntries({ history }) {
  const tabPage = (type) => {
    if (type === 1) {
      history.push({ pathname: '/m/starInstruction', search: window.location.search });
    }
    if (type === 2) {
      history.push({ pathname: '/m/starList', search: window.location.search });
    }
  };

  return (
    <ul className={styles.mobileRightEntries}>
      <li>
        <div className={`${styles.entryIcon} ${styles.strategyIcon}`} onClick={() => tabPage(1)} />
      </li>
      <li>
        <div className={`${styles.entryIcon} ${styles.detailIcon}`} onClick={() => tabPage(2)} />
      </li>
    </ul>
  );
}
